import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Pie,
    mixins: [reactiveProp],
	data() {
		return {
			options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                 },
                 tooltips: {
                    // enabled: false
                 },
                scales: {
                  xAxes: [{
                    display: false,
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                    }
                  }],
                  yAxes: [{
                    display: false,
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                        drawBorder: false,
                    },
                    ticks: {
                        beginAtZero:true
                    }
                  }]
                }
            }
		};
	},
    mounted () {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options)
    }
}